import Vue from 'vue'

const EventBus = new Vue(
    {
        data: {
            sidebar: '',
            sidebarStatus: false
        },
        methods: {
            toggleSidebar: function () {
                this.sidebarStatus = (this.sidebarStatus == true) ? false : true;
                console.log('sidebar: ' + this.sidebarStatus)
            }
        }
    }
)

export default EventBus